module.exports = __webpack_public_path__ + "static/media/gallery-2-2.eea644ca.png";